import * as THREE from 'three';
import { PORTS } from '../config.js';

// ---------------------------------------------------------------------------
// The trading areas, drawn.
//
// These shapes are hand-tuned numbers in config, and arguing about them from
// screenshots is slow. Press P on a dev machine and they are painted flat on
// the water: green where a boat counts as alongside.
// ---------------------------------------------------------------------------

export function createPortDebug(seaY) {
    const group = new THREE.Group();
    group.name = 'port-debug';
    group.visible = false;

    const material = new THREE.MeshBasicMaterial({
        color: 0x53e08a,
        transparent: true,
        opacity: 0.24,
        depthWrite: false,
        side: THREE.DoubleSide,
    });

    for (const port of PORTS) {
        let mesh = null;

        if (port.box) {
            const { x0, x1, z0, z1 } = port.box;
            mesh = new THREE.Mesh(new THREE.PlaneGeometry(x1 - x0, z1 - z0), material);
            mesh.position.set((x0 + x1) / 2, seaY + 0.12, (z0 + z1) / 2);
        }

        if (port.arc) {
            const a = port.arc;
            // Our bearings run from +Z; a ring's theta runs from +X and the
            // plane is laid down by rotating about X, which flips the sense.
            // Hence the quarter turn.
            mesh = new THREE.Mesh(
                new THREE.RingGeometry(a.r0, a.r1, 48, 1, (a.at - a.spread) - Math.PI / 2, a.spread * 2),
                material,
            );
            mesh.position.set(a.x, seaY + 0.12, a.z);
        }

        if (!mesh) continue;
        mesh.rotation.x = -Math.PI / 2;
        mesh.renderOrder = 5;
        mesh.name = `port-debug:${port.id}`;
        group.add(mesh);
    }

    return group;
}
